'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _AddPropertiesToProject = require('./AddPropertiesToProject');var _AddPropertiesToProject2 = _interopRequireDefault(_AddPropertiesToProject);
var _assetsToDelete = require('../../redux/modules/assetsToDelete');



var _messageModal = require('../../redux/modules/messageModal');

var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _creationNewHomes = require('../../redux/modules/creationNewHomes');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}






var selector = (0, _reduxForm.formValueSelector)('AddPropertiesToProject');
var changeValue = function changeValue(_ref) {var name = _ref.name,value = _ref.value;return (0, _reduxForm.change)('AddPropertiesToProject', name, value);};

var scrollToFirstError = function scrollToFirstError(errors) {
  if (!errors) {return;}

  errors.propertyBlock.filter(function (item, index) {
    var errorFields = Object.keys(item);
    return _reactScroll.scroller.scrollTo('propertyBlock[' + index + '].' + errorFields[0], {
      duration: 500,
      smooth: true,
      offset: -95 });

  });
};

var mapStateToProps = function mapStateToProps(state) {
  var route = state.routing.locationBeforeTransitions.pathname;
  var editedProperty = state.creationNewHomes.properties ? state.creationNewHomes.properties : null;
  var editPropertyIdx = route.indexOf('/project/edit');
  var editForeignProjectIdx = route.indexOf('/foreign_project/edit');
  var isEditProject =
  editPropertyIdx === 0 ||
  editPropertyIdx === 3 ||
  editForeignProjectIdx === 0 ||
  editForeignProjectIdx === 3;


  return {
    fields: {
      propertiesToProject: selector(state, 'propertyBlock') },

    initialValues: editedProperty && isEditProject && {
      propertyBlock: editedProperty },

    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    userData: state.userAuthentication.data,
    creationNewHomes: state.creationNewHomes,
    contactUs: state.contactUs,
    isMessageModalOpen: state.messageModal.isMessageModalOpen };

};exports.default =

(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  addPropetiesToProject: _creationNewHomes.addPropetiesToProject,
  addAssetToDelete: _assetsToDelete.addAssetToDelete,
  addAssetToUnsuspend: _assetsToDelete.addAssetToUnsuspend,
  changeAssetsTags: _assetsToDelete.changeAssetsTags,
  editMyPropertyByProject: _creationNewHomes.editMyPropertyByProject,
  myPropertyByProject: _creationNewHomes.myPropertyByProject,
  deleteMyPropertyByProject: _creationNewHomes.deleteMyPropertyByProject,
  hideMessageModal: _messageModal.hideMessageModal,
  openMessageModal: _messageModal.openMessageModal,
  changeValue: changeValue }),

(0, _reduxForm.reduxForm)({
  form: 'AddPropertiesToProject',
  validate: _validate2.default,
  onSubmitFail: function onSubmitFail(errors) {return scrollToFirstError(errors);} }))(_AddPropertiesToProject2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AddPropertiesToProjectForm/AddPropertiesToProjectForm.js
// module id = 2938
// module chunks = 0